export const findFixedHeaderOffset = () => {
	const header = document.getElementById('site-header');
	if (!header) return 0;
	return header.getBoundingClientRect().height;
};

export const windowScrollToElement = ({
	targetElement,
	offset = 0,
}: {
	targetElement: HTMLElement;
	offset?: number;
}) => {
	const headerOffset = findFixedHeaderOffset();
	const top = targetElement.getBoundingClientRect().top + globalThis.window.scrollY - headerOffset - offset;
	globalThis.window.scrollTo({
		top,
	});
};
